<template>
  <WdsStack direction-column>
    <WdsHeading v-if="headerText" type="subtitle">{{ headerText }}</WdsHeading>

    <WdsText v-if="subText" secondary>{{ subText }}</WdsText>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsHeading, WdsText, WdsStack } from '@worksome/wds-components'

defineProps({
  headerText: {
    type: String,
    required: false,
    default: null,
  },

  subText: {
    type: String,
    required: false,
    default: null,
  },
})
</script>
